export const COLUMNS = [
    {
        Header: "Transaction ID",
        Footer: "Transaction ID",
        accessor: "transactionId",
        sticky: "left",
    },
    {
        Header: "Product Name",
        Footer: "Product Name",
        accessor: "productname",
    },
    {
        Header: "Product Code",
        Footer: "Product Code",
        accessor: "product_code",
    },
    {
        Header: "Order Code",
        Footer: "Order Code",
        accessor: "ordercode",
    },
    {
        Header: "Value",
        Footer: "Value",
        accessor: "value",
    },
    {
        Header: "Redemption Type",
        Footer: "Redemption Type",
        accessor: "redemption_type",
    },
    {
        Header: "Product Image",
        accessor: "image",
        Cell: ({ value }) => (
            <div className="d-flex flex-wrap gap-1">
                {value?.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`Product ${index}`}
                        width={40}
                        height={40}
                    />
                ))}
            </div>
        ),
    },
    {
        Header: "Title",
        Footer: "Title",
        accessor: "title",
    },
    {
        Header: "Date",
        Footer: "Date",
        accessor: "transactionProcessedDate",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];